
import React from 'react';

export const Loading = () => {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center">
      <p className="text-sm text-gray-600">Carregando o Mozarch...</p>
    </div>
  );
};
